module.exports = __webpack_public_path__ + "static/img/manual_ja_10.0cacbf3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_10.png
// module id = 8c3/
// module chunks = 4